import styled from 'styled-components';
import { Text } from 'UI';

export const SPageContainer = styled.div`
  padding: 24px 32px;
`;

export const SCoverCard = styled.div`
  width: 665px;
  display: flex;
  flex-direction: column;
  border: 1px dashed ${({ theme }) => theme.color.grey75};
  border-radius: 8px;
  padding: 16px 24px;
  margin-top: 16px;
`;

export const SCoverRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  flex-shrink: 0;
`;

export const SCoverThumbnail = styled.img`
  width: 260px;
  height: 146px;
  object-fit: cover;
`;

export const SCoverInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1 1 auto;
`;

export const SFileName = styled(Text)`
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const SHiddenInput = styled.input`
  display: none;
`;

export const SPreviewImage = styled.img`
  max-width: 100%;
  max-height: 560px;
  object-fit: contain;
  display: block;
`;

export const SModalActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
`;

export const SGallery = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 16px;
`;

export const SGalleryCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 260px;
  border: 1px solid ${({ theme }) => theme.color.grey85};
  border-radius: 8px;
  padding: 12px;
`;

export const SDropZone = styled.div<{ $isDragging?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px dashed ${({ theme, $isDragging }) => ($isDragging ? theme.color.clear_blue : theme.color.grey85)};
  border-radius: 8px;
  padding: 32px 24px;
  margin-top: 16px;
  cursor: pointer;
  background-color: ${({ theme, $isDragging }) => ($isDragging ? theme.color.grey95 : 'transparent')};
  transition: border-color 0.2s ease, background-color 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.color.clear_blue};
    background-color: ${({ theme }) => theme.color.grey95};
  }
`;
